/* 
Copyright (c) Karsten Jeske and John Firth
This source code is licensed under the proprietary license found in the
LICENSE file in the root directory of this source tree.
*/

import { Link } from "react-router"

const Footer = () => {
  return (
    <footer className="px-4 mb-2 mb-sm-0">
      <div className="d-flex flex-wrap justify-content-between">
        <p className="col-md-6 text-start">© 2025 saferetirementspending.com</p>
        <div className="col-md-6 text-end">
          <Link className="text-decoration-none text-muted me-3" to="/privacy/">
            Privacy Policy
          </Link>
          <Link className="text-decoration-none text-muted me-3" to="/terms/">
            Terms of Service
          </Link>
          <Link className="text-decoration-none text-muted" to="/disclaimers/">
            Disclaimer
          </Link>
        </div>
      </div>
    </footer>
  )
}

export default Footer
